/**
 * 仅在开发环境数据打印
 * @param ...data 要打印的数据
 */
export const useDPrint = (...data: any) => {
  const isDev = process.env.NODE_ENV === 'development'
  if (isDev) {
    const timestamp = new Date().toLocaleString()
    console.log(`[${timestamp}]`, ...data)
  }
}
